import CreateIcon from '@mui/icons-material/Create'
import { styled } from '@mui/material/styles'

import { TableColumn } from '@/config/types'

type Props = {
  column: TableColumn
  editAction?: (payload: { id: TableColumn['accessor']; title: TableColumn['header'] }) => void
}

export default function ColumnActions(props: Props) {
  const { column, editAction } = props
  return (
    <ColumnActionsWrapper className="power-table-column-actions">
      {column.editable && editAction && (
        <ColumnActionIcon
          className="power-table-column-actions-icon"
          onClick={() => {
            editAction({ id: column.accessor, title: column.header })
          }}
        >
          <CreateIcon className="power-table-column-actions-icon" />
        </ColumnActionIcon>
      )}
    </ColumnActionsWrapper>
  )
}

const ColumnActionsWrapper = styled('div')({
  display: 'inline-block',
  paddingLeft: '2px',
  paddingTop: '2px',
  transition: 'opacity 0.3s',
  minWidth: '40px',
})

const ColumnActionIcon = styled('span')({
  fontSize: '0.8rem',
  paddingLeft: '2px',
  cursor: 'pointer',
})
